import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/close-icon-2.svg'
import _imports_1 from '@/assets/rounded-selected-checkbox.svg'


const _hoisted_1 = { class: "absolute overflow-y-auto top-5 w-[630px] p-6 mx-3 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 rounded-lg shadow-lg max-w-md" }
const _hoisted_2 = { class: "flex items-center justify-between border-b border-gray-300 pb-3" }
const _hoisted_3 = { class: "text-xl leading-[32px] tracking-[0.01rem] text-primary-text-color font-semibold" }
const _hoisted_4 = { class: "text-base leading-[26px] tracking-[0.01rem] text-[#898790] font-medium pt-4" }
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = { class: "pointer-events-none w-full outline-none text-base text-primary-text-color font-normal tracking-[0.01rem] bg-[#F9F8F6] p-3 border border-[#E3E1EA] rounded-[5px] placeholder:text-primary-text-color" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "text-base leading-[26px] tracking-[0.01rem] text-[#898790] font-medium pt-4" }
const _hoisted_9 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_10 = {
  key: 1,
  class: "mt-3 flex flex-col"
}
const _hoisted_11 = {
  key: 0,
  class: "text-sm text-red-400 font-medium mt-1"
}
const _hoisted_12 = {
  key: 2,
  class: "mt-3 flex flex-col gap-3"
}
const _hoisted_13 = { class: "flex items-center justify-center w-4 h-4 relative" }
const _hoisted_14 = ["id", "value"]
const _hoisted_15 = {
  key: 1,
  class: "cursor-pointer w-full h-full object-cover",
  src: _imports_1,
  alt: ""
}
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { class: "text-base leading-[26px] tracking-[0.01rem] text-[#898790] font-medium pt-4" }

import client from "@/utils/axios";
import { reactive } from "vue";
import SelectMenu from "./SelectMenu.vue";
import { ref } from "vue";
import { errorToast } from "@/utils/custom-toast";
import { useTranslate } from "@/composables/useTranslate";

type Props = {
  input: any;
  step: any;
  isOpen: boolean;
  project: string | string[];
  phase: number;
  termins?: Array<any>;
  groupIndex?: number;
  inputIndex?: number;
};

type Emits = {
  (event: "toggleModal"): void;
  (event: "refresh"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'InputModal',
  props: {
    input: {},
    step: {},
    isOpen: { type: Boolean },
    project: {},
    phase: {},
    termins: {},
    groupIndex: {},
    inputIndex: {}
  },
  emits: ["toggleModal", "refresh"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;
const { t } = useTranslate();
const error = ref("");

const state = reactive({
  value:
    props.input.type === "repeatable_input"
      ? props.input.value[props.inputIndex].value
      : (props.input.type === "select" ||
          props.input.type === "static_select") &&
        props.input.options &&
        props.input.value
      ? Number(props.input.value)
      : props.input.value,
});

const options = props.termins?.map((item: any) => {
  return {
    name: item.name,
    id: item.id,
  };
});

const termin = ref(
  options?.find((item: any) => item.id === props.input.terminId)
);

const onSubmit = async () => {
  if (props.project && props.phase && props.input && termin.value) {
    if (props.input.type === "number") {
      if (Number(state.value) > 7) {
        error.value = t(
          "This field is conditional and value cannot exceed 7."
        ).value;
        return;
      } else {
        error.value = "";
      }
    }

    let payload = {
      terminId: termin.value?.id,
      stepId: props.step?.id,
      inputId: props.input?.id,
      inputIndex: props.inputIndex,
      groupIndex: props.groupIndex,
      value:
        props.input.type === "select" ||
        props.input.subtype === "select" ||
        props.input.type === "static_select" ||
        props.input.subtype === "static_select"
          ? Number(state.value)
          : state.value,
    };

    try {
      await client.post(
        `/projects/${props.project}/phase/${props.phase}/update-input`,
        payload
      );

      emits("refresh");
      emits("toggleModal");
    } catch (error: any) {
      errorToast(error);
    }
  } else {
    errorToast(t("global.all_fields_required").value);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fixed overflow-y-auto inset-0 bg-black bg-opacity-80 justify-center items-center z-50 transition-opacity duration-300 ease-in-out", `${__props.isOpen ? 'flex' : 'hidden'}`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(t)("phase.input")), 1),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('toggleModal')))
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Close icon"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("form", {
        onSubmit: _withModifiers(onSubmit, ["prevent"])
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(t)("phase.question")), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(__props.input.name), 1),
              (__props.input.type === 'repeatable_input')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, " / " + _toDisplayString(__props.input.repeatableInputNoun) + " " + _toDisplayString(__props.inputIndex !== undefined ? __props.inputIndex + 1 : ""), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("h4", _hoisted_8, _toDisplayString(_unref(t)("phase.answer")), 1),
          (__props.input.type === 'text' || __props.input.subtype === 'text')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.value) = $event)),
                  rows: "4",
                  class: "w-full outline-none text-base text-primary-text-color font-normal tracking-[0.01rem] bg-[#F9F8F6] p-3 border border-[#E3E1EA] rounded-[5px] resize-none placeholder:text-primary-text-color"
                }, null, 512), [
                  [_vModelText, state.value]
                ])
              ]))
            : _createCommentVNode("", true),
          (__props.input.type === 'number')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.value) = $event)),
                  class: "w-full outline-none text-base text-primary-text-color font-normal tracking-[0.01rem] bg-[#F9F8F6] p-3 border border-[#E3E1EA] rounded-[5px] placeholder:text-primary-text-color",
                  type: "number"
                }, null, 512), [
                  [_vModelText, state.value]
                ]),
                (error.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(error.value), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (
              __props.input.type === 'select' ||
              __props.input.subtype === 'select' ||
              __props.input.type === 'static_select' ||
              __props.input.subtype === 'static_select'
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.input.options, (option) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: option.id,
                    class: "flex items-center gap-2"
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      (Number(state.value) !== option.id)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.value) = $event)),
                            id: option.id,
                            value: option.id,
                            type: "radio",
                            class: "rounded-full w-full h-full border-2 border-[#393840]"
                          }, null, 8, _hoisted_14)), [
                            [_vModelRadio, state.value]
                          ])
                        : _createCommentVNode("", true),
                      (state.value === option.id)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("label", null, _toDisplayString(option.option), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!__props.input.terminId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("h4", _hoisted_17, _toDisplayString(_unref(t)("phase.on_which_termin_picture_taken")), 1),
                _createVNode(SelectMenu, {
                  options: _unref(options),
                  modelValue: termin.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((termin).value = $event))
                }, null, 8, ["options", "modelValue"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex justify-end" }, [
          _createElementVNode("input", {
            type: "submit",
            class: "mt-5 flex items-center justify-center py-3 px-[48px] text-base text-white bg-[#393840] tracking-[0.01rem] font-semibold outline-none rounded-primary-radius border-[2px] border-[#393840] cursor-pointer hover:bg-[#28272c] duration-200",
            value: "Save"
          })
        ], -1))
      ], 32)
    ])
  ], 2))
}
}

})